import React, { useState, useContext, useEffect } from "react";
import {
  AddNewRuleCard,
  FormLeaveGuard,
  LoaderWrapper,
  WarningModal,
} from "../../../components";
import { useDeepEffect, useRequest, useRouterParams } from "../../../abstracts";
import { ManageMapperLayout } from "../../../components";
import { Button, Form } from "react-bootstrap";
import * as Yup from "yup";
import { Formik } from "formik";
import { getValidationRules, saveValidation } from "../../../services";
import {
  MANAGE_MAPPER_POST_API_ERROR,
  manageMapperStore,
  setFileUploadData,
  setManageMapperToastInfo,
  setMapperPostResponse,
} from "../../../contexts";
import { isEmpty, get, isNull } from "lodash";
import { isNullOrUndefined } from "@microsoft/applicationinsights-core-js";
import {
  MANAGE_MAPPER_ROUTES,
  ROUTES,
  getPathWithParam,
  splitParams,
} from "../../../utils";
import { useHistory } from "react-router";
const RuletabContainer = () => {
  const history = useHistory();
  const { state, dispatch } = useContext(manageMapperStore);
  const { flow, profileId, mapType } = useRouterParams();
  const [rules, setRules] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [shrink, setShrink] = useState();
  const [isSubRuleSaved, setIsSubRuleSaved] = useState(false);
  const data = get(state, "api.data", {});
  useDeepEffect(() => {
    if (!isNullOrUndefined(data?.ruleSetId)) {
      setDataLoading(true);
      getValidationRules(data.ruleSetId)
        .then((response) => {
          setRules(response);
          setDataLoading(false);
        })
        .catch((err) => {
          setDataLoading(false);
          dispatch({
            type: MANAGE_MAPPER_POST_API_ERROR,
            payload: "Something went wrong! please try again.",
          });
        });
    }
  }, [data]);
  const navigateToMapperHomePage = () => {
    history.push(
      getPathWithParam({
        path: `${ROUTES.MAPPER_HOME}`,
      })
    );
  };
  const buttons = [
    {
      label: "Cancel",
      variant: "secondary",
      type: "button",
      onClick: () => {
        setModalVisible(true);
      },
    },

    {
      label: "Next",
      variant: "primary",
      type: "submit",
    },
  ];
  // const itemSchema = Yup.object().shape({
  //   ruleErrorMessage: Yup.string().required("Required"),
  // });

  // const validationSchema = Yup.object().shape({
  //   ruleSet: Yup.array().of(itemSchema),
  // });

  const onFormSubmit = (values) => {
    setIsSubRuleSaved(true);
    var findError = values?.ruleSet?.findIndex(
      (x) => x.isErrorValidation == true
    );
    if (findError >= 0) {
      setShrink(findError);
    } else {
      const payload = {
        passthroughProfileId: profileId,
        rules: values.ruleSet?.map((item, index) => {
          return {
            id: 0,
            name: item.ruleName,
            oder: index + 1,
            isComplex: false,
            expression: item.ruleExpression,
            breakOnError: false,
            errorMessage: item.ruleErrorMessage,
            controlName: null,
            childObjectType: null,
            childPropertyName: null,
          };
        }),
      };
      setDataLoading(true);
      saveValidation(payload).then((response) => {
        if (!isEmpty(response)) {
          const outputTemplateMaps = JSON.parse(response["outputProfile"])[
            "OutputTemplateMaps"
          ];
          response = { ...response, outputTemplateMaps };
          dispatch(
            setFileUploadData({
              mappingConfiguration: response,
            })
          );
          dispatch(setMapperPostResponse(response));
          dispatch(
            setManageMapperToastInfo({
              showToast: true,
              toastMessage: "Data saved successfully",
            })
          );
          history.push(
            `${MANAGE_MAPPER_ROUTES.VERIFY_AND_MAP_OUTPUT}/${mapType}/${profileId}`
          );
          setDataLoading(false);
        } else {
          setDataLoading(false);
          dispatch({
            type: MANAGE_MAPPER_POST_API_ERROR,
            payload: "Something went wrong! please try again.",
          });
        }
      });
    }
  };
  const initialValues = {};

  function Level1Split(input) {
    const parts = [];
    let currentPart = "";
    let parenthesesCount = 0;

    for (let i = 0; i < input?.length; i++) {
      const char = input[i];

      if (char === "(") {
        parenthesesCount++;
      } else if (char === ")") {
        parenthesesCount--;
      }

      currentPart += char;

      if (
        char === " " &&
        (input.slice(i + 1, i + 4) === "And" ||
          input.slice(i + 1, i + 3) === "Or") &&
        parenthesesCount === 0
      ) {
        parts.push(currentPart.trim());
        currentPart = "";
        i += 3; // Skip "And" and whitespace
      }
    }

    if (currentPart.trim() !== "") {
      parts.push(currentPart.trim());
    }

    return parts;
  }

  function setRemoveOperator(str) {
    var operator = str?.slice(str.lastIndexOf(")") + 1, -5).trim();
    if (operator != "") {
      return str.slice(0, str.lastIndexOf(")") + 1);
    } else {
      return str.slice(str.indexOf("(") + 1, str.lastIndexOf(")"));
    }
  }

  function setOperator(string) {
    var operator = string?.slice(string.lastIndexOf(")") + 1, -5).trim();
    if (operator != "") {
      return operator;
    } else {
      return "Not";
    }
  }
  return (
    <>
      <Formik
        initialValues={{
          ...initialValues,
          ruleSet: rules?.map((itm, ind) => {
            const findOperator = setOperator(itm.expression);
            const trimExpression = setRemoveOperator(itm.expression);
            const outputArray = Level1Split(trimExpression);
            let comaSplit = outputArray.map((dataRule) => {
              return {
                a: dataRule.substring(0, dataRule.indexOf("(")),
                b: dataRule.slice(dataRule.indexOf("(") + 1, -1),
              };
            });
            return {
              id: itm.id,
              isErrorValidation: false,
              ruleName: itm.name,
              filterCondition: findOperator,
              ruleErrorLanguage: "English",
              ruleErrorMessage: itm.errorMessage,
              ruleExpression: itm.expression,
              ruleOperations: comaSplit?.map((rule) => {
                let fieldRule = splitParams(rule.b);
                return {
                  firstFieldRule: fieldRule[0],
                  conditionCategory: rule.a,
                  secondFieldRule0: fieldRule[1],
                  secondFieldRule1: fieldRule[2],
                };
              }),
            };
          }),
        }}
        enableReinitialize
        onSubmit={onFormSubmit}
        validateOnChange={false}
        validateOnBlur={false}
      >
        {({
          handleChange,
          setFieldValue,
          handleSubmit,
          setValues,
          setErrors,
          values,
          ...rest
        }) => {
          return (
            <Form
              style={{ width: "100%", height: "100%" }}
              onSubmit={handleSubmit}
            >
              <LoaderWrapper isLoading={dataLoading}>
                <ManageMapperLayout
                  buttons={buttons}
                  layoutHeader="Validations"
                >
                  <div className="rule-tab-layout">
                    <AddNewRuleCard
                      setRemoveOperator={setRemoveOperator}
                      profileId={profileId}
                      setShrink={setShrink}
                      shrink={shrink}
                      setIsSubRuleSaved={setIsSubRuleSaved}
                      isSubRuleSaved={isSubRuleSaved}
                    />
                  </div>
                </ManageMapperLayout>
              </LoaderWrapper>
            </Form>
          );
        }}
      </Formik>
      <FormLeaveGuard
        showModal={modalVisible}
        handleConfirmClick={() => navigateToMapperHomePage()}
        handleCancelClick={() => setModalVisible(false)}
      />
    </>
  );
};
export default RuletabContainer;
